<div>
    <div class="flex align-items-center justify-content-center mt-3">
        <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="dt1.filterGlobal($any($event.target).value, 'contains')"
                placeholder="Search" class=" p-inputtext-sm" />
        </span>
    </div>
    <p-table #dt1 [value]="products" [scrollable]="true" scrollHeight="350px" styleClass="p-datatable-striped"
        responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm " [paginator]="true" [rows]="5"
        [globalFilterFields]="['productCode', 'productName']" selectionMode="single" paginatorDropdownAppendTo="body"
        (onRowSelect)="SelectOption($event)" [loading]="loader" [rowsPerPageOptions]="[5, 10, 20]">

        <ng-template pTemplate="header">
            <tr>
                <th></th>
                <th>Product Code</th>
                <th>Product Name</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
            <tr (click)="SelectOption(product)">
                <td> <p-tableRadioButton [value]="product" ></p-tableRadioButton> </td>
                <td>{{product.productCode}} </td>
                <td>{{product.productName}}</td>
        </ng-template>
    </p-table>
</div>